import React, { useEffect, useState } from 'react';
import classNames from 'classnames';

import HeaderNav from 'src/components/layout/header/desktop/HeaderNav';
import withLocation from 'src/components/withLocation';

import { headerWrapper } from 'src/styles/header.module.scss';
import { isEmpty } from 'lodash';
import { useIsFTU } from 'src/components/my-plan/MyPlanContext';

const Header = ({ color, hasPreview, location, scrollPos, ...rest }) => {
    const isFTU = useIsFTU();
    const isMyPlan = !!location.pathname.match(/my-plan/);
    const isAccount = !!location.pathname.match(/account/gi);

    const [promoCollapsed, setPromoCollapsed] = useState(scrollPos > 10);

    useEffect(() => {
        if (scrollPos < 10 || scrollPos > 210) {
            setPromoCollapsed(promoCollapsed ? scrollPos > 210 : scrollPos > 10);
        }
    }, [promoCollapsed, scrollPos]);

    const headerClasses = classNames(headerWrapper, color && `bgcolor-pv-${color}`, {
        'has-preview': hasPreview,
        'page-scrolled': scrollPos > 10,
        'promo-collapsed': promoCollapsed,
        'new-experience': isMyPlan && isFTU,
        'custom-bgcolor': !isEmpty(color),
        'is-account-page': isAccount,
        'my-plan': isMyPlan,
    });

    return (
        <header className={headerClasses}>
            <HeaderNav scrollPos={scrollPos} {...rest} />
        </header>
    );
};

export default withLocation(Header);
